import { render } from "./FeederWithComponent.vue?vue&type=template&id=993a462e&scoped=true"
import script from "./FeederWithComponent.vue?vue&type=script&lang=js"
export * from "./FeederWithComponent.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-993a462e"

export default script